import { Location } from 'contexts';

export const convertFullAddress = (data: Location) => {
  return `${data.address}, ${data.wardName}, ${data.provinceName}`;
};
